import {
  DEFAULT_MAT_ID,
  GAMEMATS,
  LAST_CALL_MAT_ID,
  isGamematId,
} from '@shared/index'

export {
  DEFAULT_MAT_ID,
  GAMEMATS,
  gamematById,
  isGamematId,
  type GamematDef,
  type GamematKind,
} from '@shared/index'

export const RANDOM_MAT_ID = 'random'
export const DEFAULT_MAT_OPACITY = 70

export const CARTOON_MATS = GAMEMATS.filter((mat) => mat.kind === 'cartoon')
export const FLAT_MATS = GAMEMATS.filter((mat) => mat.kind === 'flat')
export const LEAGUE_MATS = GAMEMATS.filter((mat) => mat.kind === 'league')

/**
 * Stored preference: a catalog id, or `random` for a new pick each duel.
 */
export function parseMatId(raw: unknown): string {
  if (raw === RANDOM_MAT_ID) return RANDOM_MAT_ID
  if (typeof raw === 'string' && isGamematId(raw)) return raw
  return DEFAULT_MAT_ID
}

/**
 * Playmat visibility 0–100. 0 hides it; 100 is full art.
 */
export function parseMatOpacity(raw: unknown): number {
  const n = typeof raw === 'number' ? raw : Number(raw)
  if (!Number.isFinite(n)) return DEFAULT_MAT_OPACITY
  return Math.round(Math.min(100, Math.max(0, n)))
}

/**
 * One catalog id at random. `excludeId` avoids matching the other half
 * when the pool has more than one mat.
 */
export function pickRandomMatId(excludeId?: string): string {
  const pool = GAMEMATS.filter((mat) => {
    if (mat.id === LAST_CALL_MAT_ID) return false
    if (mat.kind === 'league') return false
    if (excludeId && mat.id === excludeId) return false
    return true
  })
  const index = Math.floor(Math.random() * pool.length)
  return pool[index]?.id ?? DEFAULT_MAT_ID
}

/**
 * Picks the texture used for this duel. Random is resolved once and stays.
 */
export function resolveDuelMatId(pref: string): string {
  const id = parseMatId(pref)
  if (id !== RANDOM_MAT_ID) return id
  return pickRandomMatId()
}

export function matTextureKey(id: string): string {
  return `gamemat-${id}`
}
